import { render, staticRenderFns } from "./frame.vue?vue&type=template&id=78c67894&scoped=true"
import script from "./frame.vue?vue&type=script&lang=js"
export * from "./frame.vue?vue&type=script&lang=js"
import style0 from "./frame.vue?vue&type=style&index=0&id=78c67894&prod&lang=scss&scoped=true"
import style1 from "./frame.vue?vue&type=style&index=1&id=78c67894&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c67894",
  null
  
)

export default component.exports